module.exports = __webpack_public_path__ + "static/media/uber.02a57714.png";